import React, { useContext, useEffect, useState } from 'react';

import { Button, Stack, Typography } from '@mui/material';
import { priceTransformer } from 'utils';
import { CartContext, SnackBarContext } from 'constants/contexts';
import QuantityInput from 'components/QuantityInput';
import { getItemPrices, getModifiersPrice } from 'utils/item';
import { env } from 'constants';
import { modifierContext } from '../ModifierProvider';

function Actions({
  onError, size, specialReq, item, onClose, available, amount, setShowModifiersError,
}) {
  const {
    getNormalizedSelectedModifiers,
    getSelectedModifiersTree,
    unSatisfiedModifiers, handleBack, parent, loading,
  } =
    useContext(modifierContext);
  const { addToCart } = useContext(CartContext);
  const [qty, setQty] = useState(amount || 1);
  const showSnackBar = useContext(SnackBarContext);

  useEffect(() => {
    setQty(amount);
  }, [amount]);
  function getActionText() {
    if (!available) {
      return 'Item is not available!';
    }
    if (parent || unSatisfiedModifiers.length > 0) {
      return 'Continue';
    }
    const modifiersPrice = getModifiersPrice(getNormalizedSelectedModifiers());
    const { price, discountedPrice } = getItemPrices({
      item,
      size,
    });
    const servingSize = item?.sizes?.find((s) => s.position === size)?.serving_size || 1;
    const finalPrice = priceTransformer(
      ((discountedPrice || price) + modifiersPrice) * qty,
    );
    if (env.IS_CATERING) {
      const pricePerPerson = ((discountedPrice || price) + modifiersPrice) / servingSize;
      return (
        <Stack direction="row" width="100%" alignItems="center" justifyContent="space-between">
          <Typography variant="label-lg">Add to cart</Typography>
          <Stack alignItems="end">
            <Typography variant="title-md">{finalPrice}</Typography>
            <Typography variant="body-overline">
              {priceTransformer(pricePerPerson)}
              {' '}
              / person
            </Typography>
          </Stack>
        </Stack>
      );
    }

    return `Add ${qty} to Cart · ${finalPrice}`;
  }

  function handleContinue() {
    if (qty < 1) {
      onError();
      showSnackBar({
        message: 'Please select amount!',
        type: 'warning',
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
      });
      return;
    }
    if (unSatisfiedModifiers.length) {
      onError();
      setShowModifiersError(true);
      showSnackBar({
        message: 'Please select required modifiers!',
        type: 'warning',
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
      });
      return;
    }
    setShowModifiersError(false);
    if (parent) {
      handleBack();
      return;
    }
    handleAddToCart();
    onClose();
  }

  function handleAddToCart() {
    addToCart({
      ...item,
      selection: {
        qty,
        size,
        message: specialReq,
        modifiers: getNormalizedSelectedModifiers(),
        modifiersTree: getSelectedModifiersTree(),
      },
    });
  }

  function handleQtyChange(value) {
    if (value === 0) {
      onClose();
      return;
    }
    setQty(value);
  }

  return (
    <Stack direction="row" spacing={2} width="100%">
      {!env.IS_CATERING && (
        <QuantityInput
          value={qty}
          onChange={handleQtyChange}
          size={42}
          min={1}
          disabled={loading}
        />
      )}
      <Button
        variant={unSatisfiedModifiers.length > 0 ? 'outlined' : 'contained'}
        fullWidth
        color="primary"
        onClick={handleContinue}
        sx={{ flex: 1, height: 56 }}
        disabled={loading || !available}
      >
        {getActionText()}
      </Button>
    </Stack>
  );
}

export default Actions;
